import dealerApiClient from '../api/dealerApiClient'
import type { DealerDashboard } from '../types'

// tz — часовой пояс браузера: бэк режет статистику по дням в нём
export async function getDashboard(from: string, to: string): Promise<DealerDashboard> {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  const { data } = await dealerApiClient.get<DealerDashboard>('/dashboard', { params: { from, to, tz } })
  return data
}
